import { Flex, Skeleton } from "antd";
import { BankStatement, COMPANY_ROLE_ENUM, COMPANY_STATUS_ENUM, COMPANY_TYPES } from "interfaces";
import { BankStatementItem } from "pages/BidInfoPage/BidInfoBlocks/BankStatements/BankStatementsBlock";
import { useCallback, useEffect, useState } from "react";
import { getCompanyById } from "services";

export const DetailsModal = (props: { companyId: string }) => {
  const { companyId } = props;
  const [loading, setLoading] = useState(false);

  const detailsInitValue: BankStatement & { amount: number } = {
    companyRegistrationNumber: "",
    bankName: "",
    bik: "",
    accountNumber: "",
    correspondentAccount: "",
    inn: "",
    kpp: "",
    companyName: "",
    type: COMPANY_TYPES.COMPANY,
    amount: 0,
    role: COMPANY_ROLE_ENUM.CUSTOMER,
    status: COMPANY_STATUS_ENUM.ACTIVE,
    fiatAmount: 0,
    fiatCurrency: "",
    isResident: false,
    rubAmount: 0,
    paymentType: "MAIN",
  };

  const [details, setDetails] = useState(detailsInitValue);

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const companyData = await getCompanyById({ id: companyId });

      setDetails((v) => ({
        ...v,
        companyRegistrationNumber: companyData ? companyData.companyRegistrationNumber : "",
        companyName: companyData ? companyData.companyName : "",
        inn: companyData ? companyData.inn : "",
        kpp: companyData ? companyData.kpp : "",
        type: companyData ? companyData.type : COMPANY_TYPES.COMPANY,
        bankName: companyData.defaultBankAccountDetails?.bankName,
        bik: companyData.defaultBankAccountDetails?.bik,
        correspondentAccount: companyData.defaultBankAccountDetails?.correspondentAccount,
        accountNumber: companyData.defaultBankAccountDetails?.accountNumber,
      }));
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    getData();
  }, [getData]);

  return loading ? (
    <Flex vertical gap="large">
      <Skeleton active />
      <Skeleton active />
      <Skeleton active />
    </Flex>
  ) : (
    <BankStatementItem
      details={details}
      title={"Реквизиты получателя"}
      id="bank-statements"
      isPaymentBlock={false}
      bgColor="bg-white"
    />
  );
};
